<template>
  <div
    class="card card-custom bg-radial-gradient-primary gutter-b card-stretch"
    :class="{ receber: fgModoPR == 'R', pagar: fgModoPR == 'P' }"
  >
    <!--begin::Header-->
    <div class="card-header border-0 py-5" style="padding-bottom: 0 !important;">
      <h3
        class="card-title font-weight-bolder text-white"
        v-if="filtroOpcao == 'Ambos'"
      >
        Progresso Títulos Emitidos por Títulos Quitados 6 Meses
      </h3>
      <h3
        class="card-title font-weight-bolder text-white"
        v-if="filtroOpcao == 'Títulos Quitados'"
      >
        Progresso Títulos Quitados 6 Meses
      </h3>
      <h3
        class="card-title font-weight-bolder text-white"
        v-if="filtroOpcao == 'Títulos'"
      >
        Progresso Títulos Emitidos 6 Meses
      </h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body d-flex flex-column p-0">
      <!--begin::Chart-->
      <img
        src="media/logos/Pulse-1s-200pxG.gif"
        v-show="fgLoading6meses"
        style="width: 150px; margin: 0 auto;"
      />
      <transition name="fade" enter-active-class="animated fadeIn">
        <GChart 
          v-if="(chartData.length > 1) && (!fgLoading6meses)" 
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
        />
      </transition>
      <!--end::Chart-->
      <!--begin::Stats-->
      <div class="card-spacer bg-white card-rounded flex-grow-1">
        <div class="row m-0">
          <div class="col px-8 py-6 mr-8">
            <div class="font-size-sm text-muted font-weight-bold">
              Grafíco de:
            </div>
            <div class="font-size-h4 font-weight-bolder" style="height: 38px;">
              <transition-group
                name="fade"
                enter-active-class="animated fadeIn"
                leave-active-class="fadede"
              >
                <div
                  key="Ambos"
                  v-show="filtroOpcao == 'Ambos'"
                  class="row m-0"
                >
                  <b-button
                    class="mr-3"
                    @click="mudaOpcaoFiltro"
                    data-placement="right"
                    data-container="body"
                    data-boundary="window"
                    v-b-tooltip.hover.right="filtroOpcaoProximo"
                  >
                    Ambos
                  </b-button>
                </div>
                <div
                  key="Títulos Quitados"
                  v-show="filtroOpcao == 'Títulos Quitados'"
                  class="row m-0"
                >
                  <b-button
                    class="mr-3"
                    @click="mudaOpcaoFiltro"
                    data-placement="right"
                    data-container="body"
                    data-boundary="window"
                    v-b-tooltip.hover.right="filtroOpcaoProximo"
                  >
                    Títulos Quitados
                  </b-button>
                </div>
                <div
                  key="Títulos"
                  v-show="filtroOpcao == 'Títulos'"
                  class="row m-0"
                >
                  <b-button
                    class="mr-3"
                    @click="mudaOpcaoFiltro"
                    data-placement="right"
                    data-container="body"
                    data-boundary="window"
                    v-b-tooltip.hover.right="filtroOpcaoProximo"
                  >
                    Títulos Emitidos
                  </b-button>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row m-0">
          <div class="col px-8 py-6 mr-8">
            <div class="font-size-sm text-muted font-weight-bold" v-if="!fgLoading6meses">
              Títulos Totais
            </div>
            <div class="font-size-h4 font-weight-bolder" v-if="!fgLoading6meses">
              {{ vendasTotais }}
            </div>
          </div>
          <div class="col px-8 py-6">
            <div class="font-size-sm text-muted font-weight-bold" v-if="!fgLoading6meses">
              Títulos Recebidos
            </div>
            <div
              class="font-size-h4 font-weight-bolder" v-if="!fgLoading6meses">
              {{ vendasRecebidas }}
            </div>
          </div>
        </div>
        <!--end::Row-->
        <!--begin::Row-->
        <div class="row m-0">
          <div class="col px-8 py-6 mr-8">
            <div class="font-size-sm text-muted font-weight-bold" v-if="!fgLoading6meses">
              Títulos Atrasados
            </div>
            <div class="font-size-h4 font-weight-bolder" v-if="!fgLoading6meses">
              {{ vendasAtrasadas }}
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Stats-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.bg-radial-gradient-primary.receber {
  background-color: #1bc5bd;
  background-image: radial-gradient(
    circle,
    rgba(201, 247, 245, 0.4),
    #1bc5bd 70%
  );
}

.bg-radial-gradient-primary.pagar {
  background-color: #f64e60;
  background-image: radial-gradient(
    circle,
    rgba(201, 247, 245, 0.4),
    #f64e60 70%
  );
}

.fadede-leave-active {
  transition: none;
}

.fadede-enter, .fadede-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { GChart } from 'vue-google-charts';

export default {
  name: "widget-10",
  components: {
    GChart
  },
  data() {
    return {
      eventAutorizado: null,
      vendasTotais: 0,
      vendasRecebidas: 0,
      vendasAtrasadas: 0,
      filtroOpcao: "Ambos",
      filtroOpcaoProximo: "Títulos Quitados",
      chartData: [],
      chartOptions: {
        colors: ["white", "rgb(105, 147, 255)"],
        legend: {position: 'none'},
        backgroundColor: {
          fill: "transparent"
        },
        hAxis: {
          textStyle:{color: '#FFF'}
        },
        vAxis: {
          textStyle:{color: '#FFF'},
          textPosition: "none",
          baselineColor: "transparent",
          gridlineColor: "transparent"
        },
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        },
        chartArea:{
          left:10,
          right:10,
          bottom:20,
          top:20,
          width:"100%",
          height:"100%"
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "fluxosDeCaixa6Meses",
      "verificado",
      "fgEmpresa",
      "fgProjeto",
      "fgPlanoFinanceiro",
      "fgCentroDeResponsabilidade",
      "fgPortador",
      "fgLoading6meses",
      "fgModoPR"
    ])
  },
  mounted() {
    let vm = this;

    this.$root.$on("buscarGrafico6MesesWidget", function() {
      vm.updateFgLoading6Meses(true);

      vm.getFluxosDeCaixa6Meses({
        tipo: vm.fgModoPR,
        empresa: vm.fgEmpresa,
        projeto: vm.fgProjeto,
        planoFinanceiro: vm.fgPlanoFinanceiro,
        centroDeResponsabilidade: vm.fgCentroDeResponsabilidade,
        portador: vm.fgPortador
      }).then(function(dados) {
        vm.updateFgLoading6Meses(false);
        vm.montaGrafico6Meses(dados);
      });
    });
  },
  beforeDestroy: function() {
    if (this.eventAutorizado) {
      this.eventAutorizado.destroy();
    }
  },
  methods: {
    ...mapActions(["getFluxosDeCaixa6Meses", "updateFgLoading6Meses"]),
    montaGrafico6Meses(dados) {
      let vm = this;

      vm.vendasTotais = 0;
      vm.vendasRecebidas = 0;
      vm.vendasAtrasadas = 0;

      let vendas = [];
      let vendasPagas = [];

      vm.chartData = [];

      Object.keys(dados).forEach(function(item) {
        if(dados[item].VALOR) {
          let valor = dados[item].VALOR;
          let valorRecebido = dados[item].VALOR_PAGO;

          if (dados[item].VALOR) {
            vm.vendasTotais += dados[item].VALOR;
          }

          if (dados[item].VALOR_PAGO) {
            vm.vendasRecebidas += dados[item].VALOR_PAGO;
          }

          if (dados[item].VALOR_ATRASADO) {
            vm.vendasAtrasadas += dados[item].VALOR_ATRASADO;
          }

          vendas.unshift(valor);
          vendasPagas.unshift(valorRecebido);

          let mes = "";
          if (item == "MES1") {
            mes = "Jan";
          } else if (item == "MES2") {
            mes = "Fev";
          } else if (item == "MES3") {
            mes = "Mar";
          } else if (item == "MES4") {
            mes = "Abr";
          } else if (item == "MES5") {
            mes = "Mai";
          } else if (item == "MES6") {
            mes = "Jun";
          } else if (item == "MES7") {
            mes = "Jul";
          } else if (item == "MES8") {
            mes = "Ago";
          } else if (item == "MES9") {
            mes = "Set";
          } else if (item == "MES10") {
            mes = "Out";
          } else if (item == "MES11") {
            mes = "Nov";
          } else if (item == "MES12") {
            mes = "Dez";
          }

          if (vm.filtroOpcao == "Ambos") {
            vm.chartOptions.colors = ["white", "rgb(105, 147, 255)"];
            vm.chartData.unshift(
              [
                mes, 
                {v: (valor ? valor : 0), f: (valor ? valor : 0).toLocaleString("pt-br", {style: "currency", currency: "BRL"})}, 
                {v: (valorRecebido ? valorRecebido : 0), f: (valorRecebido ? valorRecebido : 0).toLocaleString("pt-br", {style: "currency", currency: "BRL"})}
              ]
            );
          } else if (vm.filtroOpcao == "Títulos Quitados") {
            vm.chartOptions.colors = ["rgb(105, 147, 255)"];
            vm.chartData.unshift(
              [
                mes, 
                {v: (valorRecebido ? valorRecebido : 0), f: (valorRecebido ? valorRecebido : 0).toLocaleString("pt-br", {style: "currency", currency: "BRL"})}
              ]
            );
          } else if (vm.filtroOpcao == "Títulos") {
            vm.chartOptions.colors = ["white"];
            vm.chartData.unshift(
              [
                mes, 
                {v: (valor ? valor : 0), f: (valor ? valor : 0).toLocaleString("pt-br", {style: "currency", currency: "BRL"})}, 
              ]
            );
          }
        }
      });

      if (vm.filtroOpcao == "Ambos") {
        vm.chartData.unshift(['Mês', 'Títulos Emitidos', 'Títulos Quitados']);
      } else if (vm.filtroOpcao == "Títulos Quitados") {
        vm.chartData.unshift(['Mês', 'Títulos Quitados']);
      } else if (vm.filtroOpcao == "Títulos") {
        vm.chartData.unshift(['Mês', 'Títulos Emitidos']);
      }

      vm.vendasTotais = vm.vendasTotais.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });

      vm.vendasRecebidas = vm.vendasRecebidas.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });

      vm.vendasAtrasadas = vm.vendasAtrasadas.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });
    },
    async mudaOpcaoFiltro() {
      if (this.filtroOpcao == "Ambos") {
        this.filtroOpcao = "Títulos Quitados";
        this.filtroOpcaoProximo = "Títulos Emitidos";
      } else if (this.filtroOpcao == "Títulos Quitados") {
        this.filtroOpcao = "Títulos";
        this.filtroOpcaoProximo = "Ambos";
      } else if (this.filtroOpcao == "Títulos") {
        this.filtroOpcao = "Ambos";
        this.filtroOpcaoProximo = "Títulos Quitados";
      }

      this.updateFgLoading6Meses(true);

      let dados = await this.getFluxosDeCaixa6Meses({
        tipo: this.fgModoPR,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador
      });

      this.updateFgLoading6Meses(false);

      this.montaGrafico6Meses(dados);
    }
  }
};
</script>
